import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { salon } from '../../data/content';
import { localIntroBlocks } from '../../data/localIntro';
import { shopLabels } from '../../data/shopLabels';
import { closingHeading, quietLink } from '../../ui/sections';
import { Section } from '../shared/Section';
const LINK_CLASS = `group ${quietLink} text-ink`;

/**
 * Lokale introductie in drie leesbare blokken (voor wie zoekt op "schoonheidssalon {stad}").
 * Staat op Contact (docs/VORMGEVING.md §3); de homepage houdt "Kom langs"
 * met stad en adres, zodat de lokale vindbaarheid niet wegvalt.
 */
export function LocalIntro() {
  return <Section tone="sand" labelledBy="local-intro" contained={false} data-id="element-7520" data-mp="20g29h7rxnp3j">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-7521" data-mp="1vg65v9n5dzoi">
        <h2 id="local-intro" className={`max-w-2xl ${closingHeading} text-ink`} data-id="element-7522" data-mp="2abvulfjpwqwx">
          De duurzame schoonheidssalon van
          <span className="italic text-clay" data-id="element-7523" data-mp="25e3sxtt9tqfj"> {salon.city}</span>
        </h2>

        <ul className="mt-12 grid gap-10 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-7524" data-mp="2d80hpj55thky">
          {localIntroBlocks().map(b => <li key={b.title} className="flex flex-col border-t border-ink/15 pt-6" data-id="element-7525" data-mp="2i7lfhq8lfjw3">
              <h3 className="type-name text-ink" data-id="element-7526" data-mp="2m7vxy2dko2ru">{b.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-7527" data-mp="2mai35vczq66w">{b.body}</p>
              <div className="mt-auto pt-4" data-id="element-7528" data-mp="2r55jh6xubuae">
                {'to' in b.link ? <Link to={b.link.to} className={LINK_CLASS} data-id="element-7529" data-mp="2w5tj2h04xjg8">
                    {b.link.label}
                    <Arrow data-id="element-7530" data-mp="313v4h8l19uuv" />
                  </Link> : <a href={b.link.href} target="_blank" rel="noopener noreferrer" className={LINK_CLASS} data-id="element-7531" data-mp="35x7eacl1zx3k">
                    {b.link.label}
                    <Arrow data-id="element-7532" data-mp="39zu9mngxo05i" />
                    <span className="sr-only" data-id="element-7533" data-mp="3ex2wv2gxuudm">{shopLabels.viaWhatsApp}</span>
                  </a>}
              </div>
            </li>)}
        </ul>
      </div>
    </Section>;
}
function Arrow() {
  return <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-7534" data-mp="1jupnr57em360" />;
}